import React, { memo } from "react";

import {
  SKELETON_TEXT_HEIGHT,
  SKELETON_INPUT_HEIGHT,
} from "@hl/base-components/lib/Skeleton";
import UserSkeleton from "@hl/shared-features/lib/features/auth/UserSkeleton";
import {
  Group,
  Stack,
  Divider,
  createStyles,
  useMantineTheme,
  Skeleton,
  AppShell,
  Box,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

import { AppHeader } from "~features/layout/Header";
import MarketplaceHeaderSkeleton from "~features/marketplace/skeleton/MarketplaceHeaderSkeleton";
import MarketplaceTokenListSkeleton from "~features/marketplace/skeleton/MarketplaceTokenListSkeleton";

const useStyles = createStyles((theme) => ({
  appShellMain: {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
    [theme.fn.largerThan(theme.breakpoints.md)]: {
      paddingLeft: "40px !important",
      paddingRight: "40px !important",
    },
  },
}));

const MarketplacePageSkeleton = () => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm - 1}px)`);

  const { classes } = useStyles();

  return (
    <AppShell
      header={<AppHeader />}
      classNames={{
        main: classes.appShellMain,
      }}
    >
      <Group position="apart" align="center" mb={40}>
        <Stack>
          <Skeleton height={isMobile ? 30 : 60} width={isMobile ? 200 : 450} />
          <Group>
            <UserSkeleton />
            <Skeleton height={SKELETON_TEXT_HEIGHT} width={120} />
          </Group>
        </Stack>
        <Group spacing={8}>
          <Skeleton height={SKELETON_INPUT_HEIGHT} width={200} />
          <Skeleton height={40} width={40} />
        </Group>
      </Group>
      <MarketplaceHeaderSkeleton />
      <Group mt={40} mb="sm">
        <Skeleton height={SKELETON_TEXT_HEIGHT} width={50} />
        <Skeleton height={SKELETON_TEXT_HEIGHT} width={50} />
      </Group>
      <Divider />
      <Box my={24}>
        {!isMobile ? (
          <Group position="apart" py={16}>
            <Group spacing={"lg"}>
              <Skeleton height={SKELETON_INPUT_HEIGHT} width={100} />
              <Skeleton height={40} width={460} />
            </Group>
            <Skeleton height={SKELETON_INPUT_HEIGHT} width={208} />
          </Group>
        ) : (
          <Stack spacing={"sm"}>
            <Skeleton height={SKELETON_INPUT_HEIGHT} />
            <Group spacing={"sm"} grow noWrap>
              <Skeleton height={SKELETON_INPUT_HEIGHT} />
              <Skeleton height={SKELETON_INPUT_HEIGHT} />
            </Group>
          </Stack>
        )}
      </Box>
      <MarketplaceTokenListSkeleton />
    </AppShell>
  );
};

export default memo(MarketplacePageSkeleton);
